<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <MemberBankIFSCTable/>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import MemberBankIFSCTable from './MemberBankIFSCTable.vue'

  export default {
    name: 'member-bank-ifsc-records',
    components: {MemberBankIFSCTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/records/memberBankIFSC/MemberBankIFSC.vue